import { render, staticRenderFns } from "./GroupListSelectionView.vue?vue&type=template&id=634b8136&scoped=true&"
import script from "./GroupListSelectionView.vue?vue&type=script&lang=ts&"
export * from "./GroupListSelectionView.vue?vue&type=script&lang=ts&"
import style0 from "./GroupListSelectionView.vue?vue&type=style&index=0&id=634b8136&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634b8136",
  null
  
)

export default component.exports